<template>
  <p v-if="stamp" class="file-stamp" :title="stampTitle(label, stamp)" data-test="file-stamp">
    <span class="file-stamp-what">{{ label }}</span
    >{{ ' '
    }}<span class="file-stamp-by"
      >{{ stamp.action === 'removed' ? 'Removed by' : 'Last updated by' }}
      {{ stampLabel(stamp) }}</span
    >
  </p>
</template>

<script setup lang="ts">
/**
 * AB#22185 (Zendesk #9938) — one "Last updated by Name · date" line for a file.
 * Renders nothing when the activity log has no entry for it.
 */
import { stampLabel, stampTitle, type FileStamp } from '@/composables/useOrderFileStamps';

defineProps<{ label: string; stamp: FileStamp | null | undefined }>();
</script>

<style scoped>
.file-stamp {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 6px;
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--ink-mute);
}
.file-stamp-what {
  font-weight: 600;
  color: var(--ink-soft);
}
</style>
